var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Search'),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('SearchedFbaProducts')],1),_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('FbaBasketProducts')],1)],1),_c('FbaBarcode')],1)}
var staticRenderFns = []

export { render, staticRenderFns }